module.exports = __webpack_public_path__ + "img/retrospect-process-3.cea32dc5.jpg";